var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8342 2.72872L18 6.55851L11.4064 9L18 11.4415L15.7861 15.367L10.2995 11.0585L11.3102 18H6.88235L7.79679 11.0585L2.31016 15.4628L0 11.3936L6.54546 8.95213L0 6.60638L2.2139 2.68085L7.84492 6.98936L6.88235 0H11.3583L10.2995 6.98936L15.8342 2.72872Z",
    fill: "#F93A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.170a91cbd1d627d18be320e6e6907572.svg";
export { ForwardRef as ReactComponent };